export var SelectableOptionMenuItemType;
(function (SelectableOptionMenuItemType) {
  SelectableOptionMenuItemType[SelectableOptionMenuItemType["Normal"] = 0] = "Normal";
  SelectableOptionMenuItemType[SelectableOptionMenuItemType["Divider"] = 1] = "Divider";
  SelectableOptionMenuItemType[SelectableOptionMenuItemType["Header"] = 2] = "Header";
  SelectableOptionMenuItemType[SelectableOptionMenuItemType["SelectAll"] = 3] = "SelectAll";
})(SelectableOptionMenuItemType || (SelectableOptionMenuItemType = {}));